import styled from 'styled-components';

import {
  flexStyles,
  overflowStyles,
  sizeStyles,
  spacingStyles,
  StyledFlexProps,
  StyledOverflowProps,
  StyledSizeProps,
  StyledSpacingProps,
} from '../../styles';
import { borderRadius, boxShadows, colors, spacing } from '../../theme';

import { CardSpacingKey } from './constants';

export const CardHeader = styled.header<StyledFlexProps>`
  box-sizing: border-box;
  display: flex;
  flex-grow: 0;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${spacing[CardSpacingKey]};
  ${flexStyles}
`;

export const CardContent = styled.div<
  StyledFlexProps & StyledSpacingProps & StyledSizeProps & StyledOverflowProps
>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${spacing['8x']};
  padding: ${spacing[CardSpacingKey]};

  &:empty {
    display: none;
  }

  ${flexStyles}
  ${spacingStyles}
  ${sizeStyles}
  ${overflowStyles}
`;

export const CardRoot = styled.article<StyledFlexProps & StyledSizeProps>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${spacing['2x']};
  width: 100%;
  background-color: ${colors.white};
  border-radius: ${borderRadius['3x']};
  box-shadow: ${boxShadows.elevation2};

  ${CardHeader} + ${CardContent} {
    padding-top: 0;
  }

  ${flexStyles}
  ${sizeStyles}
`;
